/**
 * Attribut panier SupaEasy (test-jauge) — seul comportement JS restant du layout v2.
 */

const CART_ATTRIBUTE_KEY = 'test-jauge';
const CART_ATTRIBUTE_VALUE = 'true';

const setTestJaugeCartAttribute = async (value = CART_ATTRIBUTE_VALUE) => {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        [CART_ATTRIBUTE_KEY]: value
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`Cart attribute update failed: ${response.status}`);
  }

  return response.json();
};

const syncTestJaugeCartAttribute = () => {
  setTestJaugeCartAttribute(CART_ATTRIBUTE_VALUE).catch(console.error);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncTestJaugeCartAttribute);
} else {
  syncTestJaugeCartAttribute();
}

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;

    if (!form?.matches('form[action*="/cart/add"]')) return;

    syncTestJaugeCartAttribute();
  },
  true,
);
